'use strict';

const Base = require('components/Base/Base.js');

require('./IndexCollection.less');

module.exports = Base.extend({

    el: '.IndexCollection',

    events: {
        'click span.link-inner': 'onInnerLinkClick'
    },

    initialize: function () {
        Base.prototype.initialize.call(this, {});

        if (app.settings.isPhone) {
            this.$('.IndexCollection-image-1').onCustom('screen-position', function (e, data) {
                if (data.screenPosition > 0.35) {
                    this.$('.IndexCollection-image-1').animate({scrollLeft: 90}, 850, 'custom');
                    data.$el.offCustom('screen-position');
                }
            }.bind(this));
        }
    }
});
